import * as React from "react";
import { LibraryBookGold } from "../../../assets/svg/LibraryBookGold";
import { IdStyles } from "../../../less/IdStyles";
import { SvgButton } from "../svg-button/SvgButton";
export var GridItemContainerLibraryMaxLevel = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick;
    return (React.createElement(SvgButton, { name: IdStyles.LibraryBook, svg: LibraryBookGold, className: className, onClick: onClick }, children));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/GridItemContainerLibraryMaxLevel.tsx
// module id = 2701
// module chunks = 3